import $ from 'jquery';
import Swal from 'sweetalert2';

export function initTargetKinerja() {
    const pageId = $('#page-id').data('page');
    if (pageId !== 'target-kinerja') return;

    console.log('[TargetKinerja] Initializing Target Kinerja Module');

    function toggleTargetType(type) {
        if (type === 'tanggal') {
            $('#div_periode').hide();
            $('#periode').prop('required', false);
            
            $('#div_target_bulanan').hide();
            $('#target_bulanan').prop('required', false);
            
            $('#div_tanggal').show();
            $('#tanggal').prop('required', true);
            
            $('#label_target_harian').html('Target Harian / Per Tanggal <span class="text-danger">*</span>');
        } else {
            $('#div_tanggal').hide();
            $('#tanggal').prop('required', false);
            
            $('#div_periode').show();
            $('#periode').prop('required', true);
            
            $('#div_target_bulanan').show();
            $('#target_bulanan').prop('required', true);
            
            $('#label_target_harian').html('Target Harian <span class="text-danger">*</span>');
        }
        fetchRealisasi();
    }

    function fetchRealisasi() {
        const urlRealisasi = $('#formTarget').data('url-realisasi');
        const jenisPekerjaan = $('#jenis_pekerjaan').val();
        const idUp3 = $('#id_up3').val();
        const idUlp = $('#id_ulp').val();
        const idPenyulang = $('#id_penyulang').val();
        const targetType = $('input[name="target_type"]:checked').val();
        const periode = $('#periode').val();
        const tanggal = $('#tanggal').val();

        if (!jenisPekerjaan || !urlRealisasi) {
            $('#realisasi_container').addClass('d-none');
            return;
        }

        $.ajax({
            url: urlRealisasi,
            type: 'GET',
            data: {
                jenis_pekerjaan: jenisPekerjaan,
                id_up3: idUp3,
                id_ulp: idUlp,
                id_penyulang: idPenyulang,
                target_type: targetType,
                periode: periode,
                tanggal: tanggal
            },
            success: function(res) {
                if (res.status === 'success') {
                    $('#realisasi_value').text(res.realisasi);
                    $('#realisasi_container').removeClass('d-none');
                }
            },
            error: function() {
                $('#realisasi_container').addClass('d-none');
            }
        });
    }

    $('input[name="target_type"]').on('change', function () {
        toggleTargetType($(this).val());
    });

    $('#jenis_pekerjaan, #id_up3, #id_ulp, #id_penyulang, #periode, #tanggal').on('change', function() {
        fetchRealisasi();
    });

    // Handle Create New Button
    $('#btnCreateTarget').on('click', function () {
        $('#formTarget')[0].reset();
        $('#id_target').val('');
        $('#jenis_pekerjaan').val('').trigger('change');
        $('#id_up3').val('').trigger('change');
        $('#id_ulp').val('').trigger('change');
        $('#id_penyulang').val('').trigger('change');
        
        // Let periode keep its default value from HTML or set to current month
        const now = new Date();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        $('#periode').val(`${now.getFullYear()}-${month}`);
        
        const day = now.getDate().toString().padStart(2, '0');
        $('#tanggal').val(`${now.getFullYear()}-${month}-${day}`);
        
        $('#type_bulan').prop('checked', true).trigger('change');
        
        $('#modalTargetLabel span').text('Tambah Target Kinerja');
        $('#realisasi_container').addClass('d-none');
    });

    // Populate Data for Edit is handled by global-crud.js via data-url-json
    $(document).on('crud:editDataFetched', function(e, data) {
        if (pageId === 'target-kinerja') {
            $('#id_target').val(data.id_target);
            $('#jenis_pekerjaan').val(data.jenis_pekerjaan).trigger('change');
            
            // Clear cascading handlers first
            $('#id_ulp').off('cascadingComplete');
            $('#id_penyulang').off('cascadingComplete');

            // Sequentially load UP3 -> ULP -> Penyulang
            if (data.id_up3) {
                $('#id_up3').val(data.id_up3).trigger('change');
                
                if (data.id_ulp) {
                    $('#id_ulp').one('cascadingComplete', function() {
                        $('#id_ulp').val(data.id_ulp).trigger('change');
                        
                        if (data.id_penyulang) {
                            $('#id_penyulang').one('cascadingComplete', function() {
                                $('#id_penyulang').val(data.id_penyulang).trigger('change');
                            });
                        }
                    });
                }
            } else {
                $('#id_up3').val('').trigger('change');
                $('#id_ulp').val('').trigger('change');
                $('#id_penyulang').val('').trigger('change');
            }

            if (data.tanggal) {
                $('#type_tanggal').prop('checked', true).trigger('change');
                
                // Format tanggal YYYY-MM-DD
                const dateVal = data.tanggal.substring(0, 10);
                $('#tanggal').val(dateVal);
            } else {
                $('#type_bulan').prop('checked', true).trigger('change');
                $('#periode').val(data.periode);
            }
            
            $('#target_harian').val(data.target_harian);
            $('#target_bulanan').val(data.target_bulanan);
            
            $('#modalTargetLabel span').text('Edit Target Kinerja');
            $('#modalTarget').modal('show');
            
            // Wait slightly for triggers to finish before fetching realisasi
            setTimeout(fetchRealisasi, 100);
        }
    });
}
